import CONFIG from 'Config/index';

export default class WSClient {
  constructor() {
    this.channels = [];
    this.closedManual = false;
    this.reconnectTimeout = 2000;
    this.pongTimeoutId = null;
    this.pingIntervalId = null;
  }

  get isOpen() {
    return this.client && this.client.readyState === WebSocket.OPEN;
  }

  init() {
    clearTimeout(this.reconnectTimeoutId);
    if (this.closedManual) Promise.resolve();
    this.initPromise = new Promise((resolve) => {
      // There is problem to use async/await in Safari 10 here
      this._connect().then(() => {
        this.client.onclose = this.onClose.bind(this);
        this.client.onmessage = this.onMessage.bind(this);
        this.client.onerror = this.onError.bind(this);
        this.client.onopen = () => {
          this.onOpen();
          resolve();
        };
      });
    });
    return this.initPromise;
  }

  open() {
    return this.init();
  }

  // This need to be override
  async _connect() {
    this.client = new WebSocket(CONFIG.urls.notificationWS);
    return Promise.resolve(this.client);
  }

  _reconnect() {
    clearTimeout(this.reconnectTimeoutId);
    if (this.isOpen) return;
    this.reconnectTimeoutId = setTimeout(this.init.bind(this), this.reconnectTimeout);
    this.reconnectTimeout += 5000;
  }

  async send(command, data) {
    await this.initPromise;
    if (!this.client) return;
    this.client.send(JSON.stringify({
      command,
      data,
    }));
  }

  async _sendSubscribe(name, data) {
    this.send('subscribe', {
      channels: [name],
      ...data,
    });
  }

  async _sendUnsubscribe(name) {
    this.send('unsubscribe', { channels: [name] });
  }

  async subscribe(name, data = {}, handler) {
    // Avoid duplicated subscriptions
    if (this.channels.find(c => c.name === name)) return;
    this.channels.push({ name, data, handler });
    if (this.isOpen) await this._sendSubscribe(name, data);
  }

  async unsubscribe(name) {
    this.channels = this.channels.filter(c => c.name !== name);
    if (this.isOpen) await this._sendUnsubscribe(name);
    return name;
  }

  setMessageAsRead(messageId) {
    this.send('mark_read', messageId);
  }

  setAllMessagesAsRead(options = {}) {
    this.send('mark_all_read', options);
  }

  reset() {
    clearTimeout(this.reconnectTimeoutId);
    this.reconnectTimeout = 2000;
  }

  close() {
    this.closedManual = true;
    this.reset();
    if (this.client) this.client.close();
  }

  onOpen() {
    this.reconnectTimeout = 2000;
    this.closedManual = false;
    this.channels.forEach(({ name, data }) => this._sendSubscribe(name, data));
    // this.pingIntervalId = setInterval(() => this.initPing(), 6000);
  }

  onMessage(messageText) {
    if (messageText.data === 'pong') {
      clearTimeout(this.pongTimeoutId);
    } else {
      const message = JSON.parse(messageText.data);
      const channel = this.channels.find(c => c.name === message.channel);
      if (channel && channel.handler) channel.handler(message);
    }
  }

  onClose(event) {
    console.log('WebSocket closed', event); // eslint-disable-line
    if (!this.closedManual) this._reconnect();
  }

  onError() {
    this._reconnect();
  }

  initPing() {
    // send ping message for get 'pong'
    // if don't have pong message doing reconnect;
    if (this.client.readyState === 1) {
      this.send('ping');
      this.pongTimeoutId = setTimeout(() => {
        clearInterval(this.pingIntervalId);
        this.client.close();
        this.init();
      }, 7500);
    }
  }
}
